import { useLocation } from "react-router-dom";

export const useQueryParam = (name) => {
  const { search } = useLocation();
  return new URLSearchParams(search).get(name);
}